const { __ } = wp.i18n;

const i18n = {};

i18n.PENDING = __( 'Pending', 'database-cleaner' );
i18n.RENAME = __( 'Rename', 'database-cleaner' );
i18n.TITLE = __( 'Title', 'database-cleaner' );

i18n.INFO_TABLE_DROP = __( 'Remove this table', 'database-cleaner' );
i18n.INFO_TABLE_OPTIMIZE = __( 'Optimize this table (check the tutorial to learn more about it)', 'database-cleaner' );
i18n.INFO_TABLE_REPAIR = __( 'Repair this table', 'database-cleaner' );
i18n.INFO_TABLE_BULK_DROP = __( 'Remove the selected tables', 'database-cleaner' );
i18n.INFO_TABLE_BULK_OPTIMIZE = __( 'Optimize the selected tables (check the tutorial to learn more about it)', 'database-cleaner' );
i18n.INFO_TABLE_BULK_REPAIR = __( 'Repair the selected tables', 'database-cleaner' );

i18n.INFO_BULK_REFRESH = __( 'Refresh the counts', 'database-cleaner' );
i18n.INFO_BULK_DELETE = __( 'Delete the data older than the date threshold', 'database-cleaner' );
i18n.INFO_BULK_DELETE_ITEMS = __( 'Delete the selected items', 'database-cleaner' );
i18n.INFO_BULK_OPTIMIZE = __( 'Optimize the selected tables', 'database-cleaner' );
i18n.INFO_BULK_USED_BY = __( 'Assign Plugin for Selected Items', 'database-cleaner' );

i18n.INFO_UNKNOWN = __( 'The "Used By" data is only available in the Pro Version. ', 'database-cleaner' );
i18n.INFO_UNKNOWN_PRO = __( 'We have no "Used By" data for this. If you know how this is used, please let us know :)', 'database-cleaner' );

export default i18n;

